module.exports = __webpack_public_path__ + "img/PF.ff74caae.svg";